import {Component, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {NotificationService} from "../../service/notification.service";
import {HttpCustomService} from "../../../service/http-custom.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BsDatepickerConfig, BsDatepickerViewMode} from "ngx-bootstrap/datepicker";
import * as _ from 'lodash';
import * as moment from 'moment';
import {API} from "../../apis/api";
import {take} from "rxjs/operators";
import {NotificationType} from "../../constants/notification-type.enum";

@Component({
  selector: 'omni-close-meter-data',
  templateUrl: './close-meter-data.component.html',
  styleUrls: ['./close-meter-data.component.scss']
})
export class CloseMeterDataComponent implements OnInit {
  formGroup: FormGroup;
  cooperativeNo: number;
  bsConfig: Partial<BsDatepickerConfig>;
  minMode: BsDatepickerViewMode = 'month';
  message: string = '';
  minDate = moment().subtract(5, 'months').toDate();
  maxDate = moment().toDate();

  constructor(
    public dialogRef: BsModalRef,
    private notificationService: NotificationService,
    private httpService: HttpCustomService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.buildFormGroup();
  }

  closeDate() {
    this.formGroup.markAsPristine();
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      const closingTime = moment(this.formGroup.get('closingTime').value).format("MM/YYYY");
      const body = {
        cooperativeNo: this.cooperativeNo,
        closingTime: closingTime
      }
      this.httpService.post({path: API.COOPERATIVE_CLOSING_METER_DATA}, body)
        .pipe(take(1))
        .subscribe(res => {
          if (res) {
            this.dialogRef.hide();
            this.notificationService.open({
              type: NotificationType.SUCCESS,
              title: `Thành công`,
              body: `Chốt số từ tháng ${closingTime} đến hiện tại thành công`,
            });
          }
        });
    }
  }

  private buildFormGroup() {
    this.bsConfig = _.assign({}, {minMode: this.minMode});
    this.formGroup = this.fb.group({
      cooperativeNo: this.cooperativeNo,
      closingTime: [null, Validators.required]
    });
  }

  changeDate(value: any) {
    if (value) {
      const closingTime = moment(value).format('MM/YYYY');
      this.message = `Lưu ý: Hệ thống sẽ chốt số các tháng từ tháng ${closingTime} đến hiện tại`
    } else {
      this.message = '';
    }
  }
}
